import React from "react";
import { Route, Routes } from "react-router-dom";
import PermissionManagement from "../../views/hr/myworkspace/PermissionManagement/PermissionManagement";

const PermissionRouter = () => {
  return (
    <Routes>
      <Route path="permission-management" element={<PermissionManagement />} />
    </Routes>
  );
};

export default PermissionRouter;
